import {
  useAppDispatch,
  useAppSelector,
} from "../../redux-store/CustomReduxHooks";
import APIFailurePopup from "../CustomAPIFailurePopup/APIFailurePopup";
import {
  clearError,
  ErrorEventHandler,
} from "../../redux-store/reducers/CsErrorSlice";
import { useCallback, useEffect } from "react";
import { T_ApiResponse } from "../../globalTypes/GlobalTypes";
import { useLocation } from "react-router-dom";
import { triggerCleverTapEvent } from "../../utils/CleverTap";
import { CleverTapEventType } from "../../utils/CleverTapConstant";
import { CT_ScreenEvntDtls } from "../../features/Feature_CleverTap/ScreenEvents/CleverTapEventDetails";
import { SCREEN_TYPE } from "../../utils/constants";
import { R_LiRoutes } from "../../utils/Routes";
import { resetPseudoLoginSlice } from "../../features/Feature_PseudoLogin/PseudoLogin_Slice";

const ErrorComp: React.FC = () => {
  const errorState = useAppSelector((state) => state.CsErrorSlice);
  const authDispatch = useAppDispatch();
  const cmsErrState = useAppSelector(
    (state) => state.CmsSlice.CmsErrorVariablesData
  );
  const pseudoLoginData = useAppSelector((state) => state.PseudoLoginSlice);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.includes(R_LiRoutes.li_baseUrl)) {
      triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
        ScreenName: CT_ScreenEvntDtls.R_LIFE.liPolicyBondSuccess.screenName,
        ScreenType: SCREEN_TYPE.LIScreenType,
      });
    }
  }, [errorState]);

  const handleOpen = useCallback(() => {
    if (ErrorEventHandler.eventState.onClick) {
      ErrorEventHandler.eventState.onClick({ ...errorState });
      ErrorEventHandler.resetHandler();
    }
    authDispatch(clearError());
  }, [errorState]);

  const ApiErrorObj = errorState.error as any;
  const title =
    cmsErrState.find(
      (f) => f.attributes?.errorCode === ApiErrorObj?.data?.errorCode
    )?.attributes?.uiDisplayTitle || ApiErrorObj?.data?.uiDisplayTitle;
  const message =
    cmsErrState.find(
      (f) => f.attributes?.errorCode === ApiErrorObj?.data?.errorCode
    )?.attributes?.uiDisplayMessage || ApiErrorObj?.data?.uiDisplayMessage;

  const handleLinkExpirePopUpBtnClick = () => {
    authDispatch(resetPseudoLoginSlice());
    authDispatch({ type: "USER_LOGOUT" });
  };

  if (pseudoLoginData.isLinkExpired) {
    return (
      <APIFailurePopup
        open={true}
        handleOpen={handleLinkExpirePopUpBtnClick}
        customTitle={"Oops!"}
        customSubTitle={"This link has expired."}
      />
    );
  }

  return errorState.error ? (
    <APIFailurePopup
      open={true}
      handleOpen={handleOpen}
      customTitle={title}
      customSubTitle={message}
    />
  ) : null;
};
export default ErrorComp;
